import { Reducer } from 'redux'
import { WizardState, WizardPageActionTypes } from './types'
import { SelectableItemConverter } from '../../components/selectableItem/selectableItemConverters';
import { TabType } from '../../components/wizard/wizardTabs/WizardTabPane';

const initialState: WizardState = {
    isVisible: false,
    loading: false,
    wizardTab: null,
    models: [],
    infotaiments: [],
    productionPeriods: [],
    errors: undefined,
    externalWizardPageActivation: false,
    changedProductionPeriods: false,
    activateFilterOnClose: false,
    vinCheckResult: null,
    changedVinCheckResult: false,
    vinCheck: false

}

const reducer: Reducer<WizardState> = (state = initialState, action) => {
    switch (action.type) {
        case WizardPageActionTypes.FETCH_REQUEST_Models: {
            return { ...state, loading: true, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined}
        }
        case WizardPageActionTypes.FETCH_REQUEST_Infotaiments: {
            return { ...state, loading: true, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined}
        }
        case WizardPageActionTypes.FETCH_REQUEST_ProductionPeriods: {
            return { ...state, loading: true, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined}
        }

        //getting data
        case WizardPageActionTypes.FETCH_SUCCESS_Models: {
            var convertedModels = SelectableItemConverter.convertModels(action.payload);
            return { ...state, loading: false, models: convertedModels, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined }
        }
        case WizardPageActionTypes.FETCH_SUCCESS_Infotaiments: {
            var convertedInfotaiments = SelectableItemConverter.convertInfotainments(action.payload);
            return { ...state, loading: false, infotaiments: convertedInfotaiments, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined}
        }
        case WizardPageActionTypes.FETCH_SUCCESS_ProductionPeriods: {
            var convertedPeriods = SelectableItemConverter.convertPeriods(action.payload);

            return { ...state, loading: false, productionPeriods: convertedPeriods, externalWizardPageActivation: false, changedProductionPeriods: true, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined}
        }

        case WizardPageActionTypes.FETCH_REQUEST_VinCheckResult: {
            return { ...state, loading: true, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined}
        }
        case WizardPageActionTypes.FETCH_SUCCESS_VinCheckResult: {
            var vinCheckResult = action.payload;

            return { ...state, loading: false, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: true, vinCheckResult: vinCheckResult, errors: undefined}
        }
        case WizardPageActionTypes.FETCH_FAILURE_VinCheckResult: {
            var error = action.payload;

            return { ...state, loading: false, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: true, vinCheckResult: vinCheckResult, errors: error.message}
        }

        //show, hide actions
        case WizardPageActionTypes.SHOW_WizardPage: {
            var wizardPage = action.payload.wizardTab;
            var vinCheck = action.payload.vinCheck;
            var activateFilterOnClose = action.payload.activateFilterOnClose;
            return {
                ...state, isVisible: true, wizardTab: wizardPage, externalWizardPageActivation: true, changedProductionPeriods: false,
                activateFilterOnClose: activateFilterOnClose, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined, vinCheck: vinCheck
            }
        }
        case WizardPageActionTypes.HIDE_WizardPage: {
            return { ...state, isVisible: false, externalWizardPageActivation: false, changedProductionPeriods: false, changedVinCheckResult: false, vinCheckResult: vinCheckResult, errors: undefined }
        }

        default: {
            return state;
        }
    }
}

export { reducer as wizardPageReducer }
